import { DailyVideoSession } from './DailyVideoSession'
import { useRemoteSessionId } from '../hooks/useRemoteSessionId'

export function RemoteVideo() {
  const { remoteSessionId } = useRemoteSessionId()

  return (
    <div className='flex h-full w-full justify-center'>
      <DailyVideoSession
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        sessionId={remoteSessionId}
        className='!object-cover'
      />
    </div>
  )
}
